var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHalfStar = function SvgHalfStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "hsl(36.5 100% 50%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "hsl(160 8% 79%)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54272 0.348145L8.39673 4.29767L12.5427 4.9349L9.54272 8.00745L10.2507 12.3481L6.54272 10.2977L2.83472 12.3481L3.54272 8.00745L0.542725 4.9349L4.68872 4.29767L6.54272 0.348145Z",
    fill: "url(#grad)"
  })));
};
export default SvgHalfStar;